import type { ITooltip } from './Tooltip'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'

export const TooltipTitle = styled.div``

export const TooltipSC = styled.div<ITooltip>`
  --arrow-width: ${({ arrow, arrowWidth }) =>
    arrow ? `${arrowWidth}` : `0px`};
  display: flex;
  position: relative;
  width: 100%;

  & ${TooltipTitle} {
    position: absolute;
    top: 100%;
    padding: ${({ paddings }) =>
      paddings && paddings.length > 0
        ? paddings.map((item) => `var(${item})`)?.join(' ')
        : 0};
    background-color: ${({ backgroundColorDefault }) =>
      `var(${backgroundColorDefault})`};
    border-radius: ${({ corners }) => `var(${corners})`};
    margin-top: ${({ margins }) =>
      margins ? `calc(var(${margins[0]}) + var(--arrow-width))` : 0};
    z-index: 5;
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    width: min(100%, max-content);

    > ${TextBoxSC} {
      display: -webkit-box;
      white-space: normal;
    }

    ::before {
      content: '';
      position: absolute;
      display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
      width: 0;
      left: ${({ arrowAlign }) => (arrowAlign === 'TopLeft' ? '0' : '50%')};
      top: 0;
      border: var(--arrow-width) solid transparent;
      border-top: 0;
      border-bottom: ${({ backgroundColorDefault }) =>
        `var(--arrow-width) solid var(${backgroundColorDefault})`};
      transform: ${({ arrowAlign }) =>
        arrowAlign === 'TopLeft'
          ? 'translate(100%, -100%)'
          : 'translate(0%, -100%)'};
      visibility: ${({ arrow }) => (arrow ? 'visible' : 'hidden')};
    }
`
